module.exports = __webpack_public_path__ + "media/theme/tutorial__psn--9--create-2a0b2ab5.jpg";